export default __webpack_public_path__ + "media/images/ideal-ca4d4671cb8208e7d560248e519ef036.svg";